import {
  Box,
  Chip,
  Stack,
  Theme,
  useTheme,
  Divider,
  Container,
} from "@mui/material";
import { useRouter } from "next/router";
import React from "react";
import { useCssMediaQuery } from "@/shared/base/hooks/useCssMediaQuery";
import { purchaseSeatsTabUIDs as tabUIDs } from "@/global/config/constants";
import { useAppSystem } from "@/global/hooks/useAppSystem";

export function TabHeader() {
  const { teamConfig } = useAppSystem();
  const { languages, purchaseSeatConfigs } = teamConfig;
  const { isPackageEnabled } = teamConfig.packageConfigs;
  const headerRef = React.useRef();
  const theme = useTheme();
  const { sm: smDown } = useCssMediaQuery("down");
  const styles = useStyles(theme);
  const router = useRouter();
  const purchaseSeatTab = router.query.purchaseSeatTab as any;

  const purchaseSeatTabTitle = languages?.purchaseSeats?.purchaseSeatTabTitle || "Choose Games"; // prettier-ignore
  const chooseSeatsTabTitle = languages?.purchaseSeats?.chooseSeatsTabTitle || "Choose Seats"; // prettier-ignore
  const chooseAddOnsTabTitle = languages?.purchaseSeats?.chooseAddOnsTabTitle || "Choose Add-Ons"; // prettier-ignore

  const tabLabels = [
    {
      uid: tabUIDs.findGames,
      name: purchaseSeatTabTitle,
      isVisible: true,
    },
    {
      uid: tabUIDs.chooseSeats,
      name: chooseSeatsTabTitle,
      isVisible: true,
    },
    {
      uid: tabUIDs.selectPerks,
      name: chooseAddOnsTabTitle,
      isVisible: purchaseSeatConfigs?.isPerksEnabled,
    },
    {
      uid: tabUIDs.checkout,
      name: "Checkout",
      isVisible: true,
    },
  ];

  return (
    <Container maxWidth="xl">
      <Box ref={headerRef} py={smDown ? 3 : 4} sx={styles.tabHeader}>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {tabLabels
            .filter((itm) => itm.isVisible)
            .map((itm, idx) => {
              return (
                <React.Fragment key={idx}>
                  <TabIndicator
                    key={idx}
                    itemIndex={idx + 1}
                    name={itm.name}
                    uid={itm.uid}
                    isSelected={
                      purchaseSeatTab == itm.uid ||
                      (isPackageEnabled &&
                        itm.uid == "find_games" &&
                        purchaseSeatTab == tabUIDs.packages)
                    }
                    onClick={() => {}}
                  />

                  {idx !==
                  tabLabels.filter((itm) => itm.isVisible).length - 1 ? (
                    <Divider orientation="horizontal" sx={styles.divider} />
                  ) : null}
                </React.Fragment>
              );
            })}
        </Stack>
      </Box>
    </Container>
  );
}

interface TabIndicatorProps {
  name: string;
  uid: string;
  itemIndex: number;
  isSelected: boolean;
  onClick: () => void;
}

function TabIndicator(props: TabIndicatorProps) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const { sm: smDown, md: mdDown } = useCssMediaQuery("down");
  const { itemIndex, uid, name, isSelected, onClick } = props;

  let label;
  if (mdDown) {
    label = isSelected ? `${itemIndex}. ${name}` : `${itemIndex}.`;
  } else {
    label = `${itemIndex}. ${name}`;
  }

  return (
    <Chip
      size={mdDown ? "small" : "large"}
      clickable={false}
      variant={isSelected ? "filled" : "outlined"}
      color={isSelected ? "primary" : "default"}
      label={label}
      // onClick={() => onClick()}
      sx={styles.tabIndicator}
    />
  );
}

function useStyles(theme: Theme) {
  return {
    tabHeader: {
      // position: "sticky",
      // top: "120px",
      // zIndex: 1,
    },
    divider: {
      flexGrow: "1",
      marginLeft: "20px",
      marginRight: "20px",
      [theme.breakpoints.down("sm")]: {
        marginLeft: "8px",
        marginRight: "8px",
      },
    },

    tabIndicator: {
      transition: "all 0.3s ease",
      fontWeight: 700,
      // paddingLeft: "12px",
      // paddingRight: "12px",
      padding: "16px 12px 16px 12px",
      "&.MuiChip-outlined": {
        backgroundColor: theme.palette.background.paper,
        "&:hover": {
          // backgroundColor: theme.palette.grey["200"],
        },
      },
    },
  };
}
